import { useEffect, useState } from "react";

import { getNativePermissionStatus } from "@/lib/notificationBridge";

type SystemBridgeWindow = Window & {
  SystemBridge?: {
    onNotificationPermissionChange: ((status: string) => void) | null;
  };
};

/**
 * 네이티브 알림 권한 상태를 추적하는 훅.
 * - 마운트 시 현재 권한 조회
 * - 앱 포그라운드 복귀 시 자동 갱신 (SystemBridge 이벤트)
 *
 * 웹 브라우저 환경에서는 항상 null (네이티브 아님).
 */
export function useNotificationPermission() {
  const [status, setStatus] = useState<string | null>(null);

  // 초기 권한 조회
  useEffect(() => {
    getNativePermissionStatus().then(s => setStatus(s));
  }, []);

  // 포그라운드 복귀 시 권한 변경 수신
  useEffect(() => {
    const win = window as SystemBridgeWindow;

    if (!win.SystemBridge) {
      return;
    }

    win.SystemBridge.onNotificationPermissionChange = (newStatus: string) => {
      setStatus(newStatus);
    };

    return () => {
      if (win.SystemBridge) {
        win.SystemBridge.onNotificationPermissionChange = null;
      }
    };
  }, []);

  const isGranted = status === "granted";
  const isDenied = status !== null && status !== "granted";
  const isNativeApp = status !== null;

  return { status, isGranted, isDenied, isNativeApp };
}
